<template>
  <RevContainer class="mx-0 my-20">
    <h1 class="heading-1 px-0 py-20 md:pt-32">
      {{ i18n(translations.title) }}
    </h1>
    <CookiesSettings
      :button-label="i18n(translations.save)"
      :shrink-button-desktop="true"
      :tracking-zone="trackingZone"
      @error="openToast('error')"
      @success="openToast('success')"
    />
  </RevContainer>
</template>

<script lang="ts" setup>
import { useRoute, useTheToast } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'

import { useBackmarketHead } from '~/composables/useBackmarketHead'

import { CookiesSettings } from '../components/CookiesSettings'
import { COOKIES_TRACKING_PREFIX } from '../constants'

import translations from './Cookies.translations'

const route = useRoute()
const i18n = useI18n()
const { openErrorToast, openSuccessToast } = useTheToast()

const trackingZone = computed(
  () => `${COOKIES_TRACKING_PREFIX}_${route.name?.toString()}`,
)

function openToast(type: 'error' | 'success') {
  if (type === 'success') {
    openSuccessToast({
      title: i18n(translations.toastSuccessTitle),
      content: i18n(translations.toastSuccessMessage),
    })
  } else {
    openErrorToast({
      title: i18n(translations.toastErrorTitle),
      content: i18n(translations.toastErrorMessage),
    })
  }
}

useBackmarketHead({
  title: i18n(translations.titleSeo),
})
</script>
